// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vis-lock {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 36px 22px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.vis-lock-ico {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fef3c7;
  color: #b45309;
}

.vis-lock h2 {
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 800;
}

.vis-lock p {
  max-width: 420px;
  font-size: 0.9rem;
  line-height: 1.6;
  color: var(--muted);
}

.vis-lock ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 6px 0 8px;
  text-align: left;
}

.vis-lock li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
  color: var(--text-soft);
}

.vis-lock .f-submit {
  max-width: 360px;
}

.vis-grid {
  display: grid;
  gap: 14px;
  margin-top: 18px;
}

.vis-cats,
.vis-viewers {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.vis-cats li {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
  font-size: 0.86rem;
}

.vis-cats li:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.vis-viewers li {
  display: flex;
  align-items: center;
  gap: 10px;
}

.vis-viewers img,
.vis-viewers span {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.vis-viewers span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--grad-brand);
  color: #fff;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 0.82rem;
}

.vis-viewers strong {
  display: block;
  font-size: 0.9rem;
}

.vis-viewers em {
  font-style: normal;
  font-size: 0.76rem;
  color: var(--muted2);
}

@media (min-width: 860px) {
  .vis-grid {
    grid-template-columns: 1fr 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/provider/ProviderVisibility.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".vis-lock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  padding: 36px 22px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.vis-lock-ico {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.vis-lock h2 {\n  font-family: var(--font-display);\n  font-size: 1.2rem;\n  font-weight: 800;\n}\n\n.vis-lock p {\n  max-width: 420px;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n.vis-lock ul {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 6px 0 8px;\n  text-align: left;\n}\n\n.vis-lock li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.88rem;\n  color: var(--text-soft);\n}\n\n.vis-lock .f-submit {\n  max-width: 360px;\n}\n\n.vis-grid {\n  display: grid;\n  gap: 14px;\n  margin-top: 18px;\n}\n\n.vis-cats,\n.vis-viewers {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.vis-cats li {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.86rem;\n}\n\n.vis-cats li:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.vis-viewers li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.vis-viewers img,\n.vis-viewers span {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.vis-viewers span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--grad-brand);\n  color: #fff;\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 0.82rem;\n}\n\n.vis-viewers strong {\n  display: block;\n  font-size: 0.9rem;\n}\n\n.vis-viewers em {\n  font-style: normal;\n  font-size: 0.76rem;\n  color: var(--muted2);\n}\n\n@media (min-width: 860px) {\n  .vis-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
